import ScreenshotMode from './ScreenshotMode';

export default ScreenshotMode;
